import React from 'react';
import { AnimatedSection } from '../components/ui/AnimatedSection';
import { SectionHeading } from '../components/ui/SectionHeading';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Michael R.',
    result: 'Lost 45 lbs & Reversed Pre-diabetes',
    quote: 'I had tried every diet imaginable. BioShift was the first program that actually looked at my blood work and fixed my metabolism. The strength training gave me my confidence back, and my energy is higher than it was in my 20s.'
  }, {
    name: 'Sarah T.',
    result: 'Restored Hormonal Balance',
    quote: "As an executive, stress had completely wrecked my hormones. Elisa's approach to functional nutrition and mindset recalibration changed everything. I sleep better, think clearer, and finally feel strong in my own body."
  }, {
    name: 'David L.',
    result: 'Gained 12 lbs of Muscle',
    quote: 'I thought I was just getting old and losing my edge. The BioShift Longevity Program showed me that muscle is the organ of longevity. The structured programming and accountability were exactly what I needed.'
  }, {
    name: 'Jessica M.',
    result: 'Overcame Chronic Fatigue',
    quote: 'The faith and fitness integration was the missing piece for me. Viewing my health as stewardship completely shifted my mindset. I no longer work out to look good; I train to be capable and energetic for my family.'
  }, {
    name: 'James C.',
    result: 'Corporate Wellness Success',
    quote: 'We brought BioShift into our company for the executive team. The results have been staggering. Not only are our leaders physically healthier, but the mental resilience and focus have directly impacted our bottom line.'
  }, {
    name: 'Robert K.',
    result: 'Sustained Weight Loss',
    quote: 'No gimmicks. Just pure science, hard work, and truth. BioShift taught me discipline. I lost 30 pounds, but more importantly, I learned how to keep it off forever by understanding my own metabolic data.'
  }];
  return <main className="w-full pt-24" data-id="element-942">
      <section className="py-20 md:py-32 bg-dark" data-id="element-943">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-944">
          <AnimatedSection data-id="element-945">
            <SectionHeading overline="Success Stories" title="Client Transformations" description="Real results from high-performers who committed to the process, trusted the science, and put in the work." data-id="element-946" />
          </AnimatedSection>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-20" data-id="element-947">
            {testimonials.map((testimonial, i) => <AnimatedSection key={i} delay={i * 0.1} data-id="element-948">
                <div className="bg-surface border border-border p-8 h-full flex flex-col justify-between relative" data-id="element-949">
                  <div data-id="element-950">
                    <div className="flex text-gold mb-6" data-id="element-951">
                      {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-current" data-id="element-952" />)}
                    </div>
                    <p className="text-muted italic leading-relaxed mb-8" data-id="element-953">
                      "{testimonial.quote}"
                    </p>
                  </div>
                  <div className="border-t border-border pt-6" data-id="element-954">
                    <p className="text-white font-bold font-heading text-lg" data-id="element-955">
                      {testimonial.name}
                    </p>
                    <p className="text-gold text-sm font-medium mt-1" data-id="element-956">
                      {testimonial.result}
                    </p>
                  </div>
                </div>
              </AnimatedSection>)}
          </div>
        </div>
      </section>
    </main>;
}